import { ChartBarIcon, FileTextIcon, PenNibIcon } from '@phosphor-icons/react';

import { SidebarLayoutSecondaryTab } from 'layouts/SidebarLayout';

export default function getUnitTransferRequestTabs(requestId: string): SidebarLayoutSecondaryTab[] {
  return [
    {
      key: 'overview',
      label: 'Overview',
      description: 'Status, SLA, and history',
      route: `/invest/unit-transfers/${requestId}`,
      icon: ChartBarIcon,
      exact: true,
    },
    {
      key: 'documents',
      label: 'Documents',
      description: 'Checklist and uploads',
      route: `/invest/unit-transfers/${requestId}/documents`,
      icon: FileTextIcon,
    },
    {
      key: 'signatures',
      label: 'Signatures',
      description: 'Documents that need your signature',
      route: `/invest/unit-transfers/${requestId}/signatures`,
      icon: PenNibIcon,
    },
  ];
}
